<template>
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.9279 22.1091C17.1649 19.3492 19.4769 17.1824 22.2981 17.1824C25.1194 17.1824 27.4311 19.3492 27.6683 22.1091C33.6825 23.6225 38.7106 27.6171 41.5978 32.9434C43.2591 29.8568 44.2037 26.327 44.2037 22.5759C44.2037 10.4778 34.3963 0.670128 22.2981 0.670128C10.2 0.670128 0.392578 10.4778 0.392578 22.5759C0.392578 26.327 1.33695 29.8568 2.99818 32.9434C5.8854 27.6171 10.9138 23.6225 16.9279 22.1091Z"
            :fill="fill"
        />
        <path
            d="M22.298 37.9891C19.319 37.9891 16.9043 40.4041 16.9043 43.3828C16.9043 43.5289 16.9146 43.6726 16.926 43.8156C16.927 43.827 16.9268 43.8386 16.9278 43.85C18.6464 44.2825 20.445 44.5146 22.298 44.5146C24.151 44.5146 25.9493 44.2825 27.6682 43.85C27.6689 43.8386 27.6689 43.827 27.6698 43.8156C27.6812 43.6726 27.6918 43.5289 27.6918 43.3828C27.6918 40.4041 25.2768 37.9891 22.298 37.9891Z"
            :fill="fill"
        />
    </svg>
</template>

<script setup>
    const props = defineProps({
        fill: {
            type: String,
            default: "#ffffff"
        }
    });
</script>
